import instance from '../_http';

export default {
    /**
     * 添加
     * @param {*} website
     * @returns
     */
    add: (website) => {
        return instance.post('/api/common/plan/savePlan',website);
    },
    /**
     *  删除
     */
    remove: (id) => {
        return instance.delete(`/api/common/plan/${id}`);
    },
    /**
     * 更新
     * @param {*} website
     * @returns
     */
    update: (website) => {
        return instance.put('/api/common/plan',website);
    },
    /**
     * 查询
     * @param {*} query
     * @returns
     */
    query: (query,page) => {
        return instance.get('/api/common/plan',{params:{...query,page:page.page,size:page.size,sort:page.sort}});
    },
    /**
     * 详情
     * @param {*} id
     * @returns
     */
    detail: (id) => {
        return instance.get(`/api/common/plan/${id}`);
    },
    /**
     * 修改状态
     * @param {*} id
     * @param {*} value
     * @returns
     */
    changeStatus: (id,value)=>{
      return instance.put(`/api/common/plan/${id}/status/${value}`);
    },

    userList: () => {
    return instance.get('/api/common/plan/cscpUser');
   }

}
